import graphql from './graphql';

const query = /* GraphQL */ `
  query User_getCertification($courseId: ID!, $userId: ID!) {
    User_getCertification(courseId: $courseId, userId: $userId) {
      id
      expirationDate
    }
  }
`;

const UserGetCertification = async ({ courseId, userId }) =>
  graphql(query, { courseId, userId })
    // eslint-disable-next-line camelcase
    .then(({ User_getCertification }) => User_getCertification)
    .catch(err => err);

export default UserGetCertification;
